export enum QuoteInputState {
  Disabled = 'disabled',
  Editable = 'editable',
  Readonly = 'readonly',
}
